'use strict';
/*
 * Novicell master
 * Use this file to call functions in other files, on document ready, window.resize etc.
 */

var novicell = novicell || {};
var adp = adp || {};

// Document ready
document.addEventListener('DOMContentLoaded', function () {
    novicell.cookieInfo.init();
    novicell.siteNavigation.init();
    novicell.slideshow.init();
    novicell.search.init();
    novicell.list.init();
    novicell.brandSlider.init();
    novicell.filterSection.init();
    novicell.keyNumbers.init();
    novicell.languagePicker.init();
    novicell.embedMedia.init();
    novicell.accordion.init();
    novicell.imageMap.init();
    novicell.gridSection.init();
    novicell.tabs.init();
    novicell.multiModal.init();

    /* Helpers */
    novicell.helper.buttonsWithLink();

    //SetTimeout to fix latency with loaded elements in e.g. Vue components
    setTimeout(() => {
        svg4everybody(); // Fix SVG spritemap in IE/Edge
    });
});

document.addEventListener('scroll', function (e) {
    novicell.keyNumbers.init();
});

// Docs for debounce https://github.com/component/debounce
window.onscroll = novicell.debounce(onScroll, 100);

window.onresize = novicell.debounce(resize, 200);

function resize() {
    novicell.keyNumbers.init();
}

function onScroll() {
    novicell.keyNumbers.init();
    novicell.siteNavigation.onWindowScroll();
}
